
<div class="search-container" #searchContainer>
  <form
    #searchForm="ngForm"
    class="relative bottom-[0.25rem] mx-auto mb-7 flex w-full max-w-full flex-col md:mb-[2.75rem]"
    [shebaGtmSearch]="{
      default: { user_action: 'user_search_' + searchText() },
      t15: { user_action: 'user_search_doctor' }
    }"
    (ngSubmit)="search()"
  >
    <div class="relative w-full">
      <input
        #searchInputRef="ngModel"
        class="h-16 w-full max-w-full overflow-hidden overflow-ellipsis whitespace-nowrap rounded-full bg-white pe-14 ps-6 text-lg shadow-[0_6px_14px_2px_rgba(93,95,133,0.20)] placeholder:text-lg placeholder:!leading-6 placeholder:text-[#25252D] md:h-14"
        name="search"
        [ngModel]="currentInput()"
        [ngClass]="{ 
          'border border-red-500': searchInputRef.invalid && (searchInputRef.dirty || searchInputRef.touched),
          'custom-class': customClass() 
        }"
        [placeholder]="placeholder()"
        (ngModelChange)="onInputChange($event)"
        (blur)="onBlur()"
        autocomplete="off"
        [pattern]="allowedCharsPattern"
      />
      <div class="border-1 absolute bottom-0 end-0 top-0 flex place-content-center place-items-center pe-[0.875rem]">
        <button class="flex h-12 w-12 place-content-center place-items-center rounded-full p-[0.313rem]" type="submit">
          <sheba-search-icon />
          <span class="sr-only">{{ 'SHARED.ACCESSIBILITY.SEARCH_ICON' | translate }}</span>
        </button>
      </div>
    </div>
    @if (searchInputRef.invalid && (searchInputRef.dirty || searchInputRef.touched)) {
      <div class="ps-6 pt-1 text-sm text-red-500">
        {{ 'FORM.ERRORS.PATTERN' | translate }}
      </div>
    }
  </form>
</div>

<ng-template #suggestionsTpl>
  @if(currentInput() && currentInput().length >= 3) {
    <div class="suggestions-dropdown">
      <ul class="suggestions-list">
        <li
          *ngFor="let suggestion of suggestions()"
          [innerHTML]="suggestion.title | highlight: currentInput()"
          (mousedown)="selectSuggestion(suggestion)"
        ></li>
      </ul>
    </div>
  }
</ng-template>